<template>
  <form v-on:submit.prevent="submitForm">

    <h2>Tenders</h2>
    <div class="form-group"><label for="id">ID :</label><input class="form-control" id="id" readonly="readonly" v-model="tender.id"/></div>
    <div class="form-group"><label for="tenderCode">Tender Code : </label><input class="form-control" id="tenderCode" v-model="tender.tenderCode"/></div>
    <div class="form-group"><label for="tenderName">Tender Name : </label><input class="form-control" id="tenderName" v-model="tender.tenderName"/></div>
    <div class="form-group"><label for="tenderType">Tender Type : </label><input class="form-control" id="tenderType" v-model="tender.tenderType"/></div>
    <div class="form-group"><label for="tenderGroup">Tender Group : </label><input class="form-control" id="tenderGroup" v-model="tender.tenderGroup"/></div>
    <div>
      <p>
        <input class="btn btn-edit" type="submit" value="Submit">
      </p>

      <router-link class="btn btn-cancel" v-bind:to="{path: 'tenders'}">
        <v-icon>mdi-cancel</v-icon>
        <input class="btn" type="submit" value="Cancel">
      </router-link>
    </div>
  </form>
</template>

<script>
import {parameters} from "../../parameters";
import {httpClient} from "../../requesters/httpClient";

export default {
  name: 'EditTender',

  async created() {
    await httpClient.get(`${parameters.posdataRefUrl}/tenders/` + this.$route.query.id)
      .then((response)=> {
        this.tender = response.data;
      })
      .catch((error)=> {
        throw error;
      });
  },
  data() {
    return {
      tender: []
    }
  },
  methods: {
    async submitForm(e) {
      if (!this.areFieldsEmpty()) {
        await httpClient.put(`${parameters.posdataRefUrl}/tenders`, this.tender);

        await this.$alert("The tender was overwritten THEN updated");

        await this.$router.push('tenders');

        e.preventDefault();
      } else {
        await this.$alert("Some mandatory fieds are empty")
      }
    },
    areFieldsEmpty: function(){
      if (this.tender.tenderCode === '' || this.tender.tenderName === ''
        || this.tender.tenderType === '' || this.tender.tenderGroup === ''){
        return true;
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/tenders/EditTender.vue